import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { MatSliderChange } from '@angular/material/slider';
import { AppService } from 'src/app/core/services/app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TipsFeedbackPopupComponent } from '../../user/tips-feedback-popup/tips-feedback-popup.component';
import { UserService } from 'src/app/core/services/user.service';
declare let $: any;
@Component({
  selector: 'app-music-player',
  templateUrl: './music-player.component.html',
  styleUrls: ['./music-player.component.scss']
})
export class MusicPlayerComponent implements OnInit {

  settingsData: any = {};
  settingsDataSubscription: Subscription;
  selected_music: any = {};
  musicList: any = [];
  subscribedUserPlans: any = [];
  audioVolume = 0.7;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  audioInterval: any;
  mediaPlayerDataSubscription: Subscription;
  performerInfoSubscr: Subscription;
  plans: any;
  performer_details: any;
  performerId: any;
  org_info: any = {};
  subEvents: any;
  ALbumStatusSubscr: Subscription;
  albumstatus: boolean = true;
  playedFromAlbum = "";

 
  musicListLength: any;
  noAds: boolean = false;
  constructor(
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private appService: AppService,
    private activatedRoute: ActivatedRoute, public sanitizer: DomSanitizer,
    private dialog: MatDialog, private userService: UserService) {
  }

  ngOnInit() {

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });

    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    });

    if (this.commonSubscribeService.mediaPlayerData.musicList) {
      this.musicList = this.commonSubscribeService.mediaPlayerData.musicList;
      this.musicListLength = this.musicList.length / 2

    }
    this.ALbumStatusSubscr = this.commonSubscribeService.getAlbumStatus().subscribe(res => {
      if (res == "newOpend") {
        this.albumstatus = true;
      }
      if (res == "playedsong") {
        this.playedFromAlbum = "play"
        if (this.albumstatus) {
          this.songsCount = 0;
        }
      }
    })
    if (this.commonSubscribeService.mediaPlayerData.subscribedUserPlans) {
      this.subscribedUserPlans = this.commonSubscribeService.mediaPlayerData.subscribedUserPlans;
    }
    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    });

    if (Object.keys(perfomerInfoData).length > 0) {
      this.getPerformerInfo(perfomerInfoData);
    }

    this.mediaPlayerDataSubscription = this.commonSubscribeService.getMediaPlayerData().subscribe(response => {
      if (response.type == "function") {
        if (response.key == "toggleAudio") {
          this.toggleAudio(response.value.selected_music, response.value.index);
        }
      } else {
        if (response.key == "musicList") {
          this.musicList = response.value;
          this.musicListLength = this.musicList.length / 2
        } else if (response.key == "subscribedUserPlans") {
          this.subscribedUserPlans = response.value;
        }
      }
    });

    this.audioInterval = setInterval(() => {
      this.getAudioTime();
    }, 1000);


  }

 
  getPerformerInfo(response, type?, from?) {
    if (response && response.data && response.data.statusCode === '200') {
      this.performerId = (response.data.Data && response.data.Data[0]) ? response.data.Data[0].performer_id : null;
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].org_info) {
        this.org_info = response.data.Data[0].org_info;
        if (this.org_info && this.org_info.vod_site_id) {
          this.getAds("data")
        }
      }
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].plans) {
        this.plans = response.data.Data[0].plans;
      }
      if (response && response.data && response.data.Data && response.data.Data[0] && response.data.Data[0].performer_details) {
        this.performer_details = response.data.Data[0].performer_details;
      }


    }
    //console.log("PERFORMER PLANS:", this.plans)
  }
  noloader: boolean = false;
  adVideo: any;
  showAd = false;
  showTimer: any = false;
  AdsCount: number = 1;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata = [];

  async getAds(from?) {
    let allDiv = [];
    let count = 0;
    var temp_site_id = null;
    this.preloadAdsdata = [];
    // if (this.streamAdsData && this.streamAdsData.length > 0) {
    //console.log('Stream page ads', this.streamAdsData);
    this.sponsorData = this.streamAdsData;
    var j = 0;
    var i = 1;
    var adTypeIdarr = [];
    var placements = [];
    // this.streamAdsData.forEach(el => {
    // temp_site_id = Number(el.site_id)
    j += 1;
    // adTypeIdarr.push(el.adTypeId);
    placements.push(
      {
        "divName": "div1",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [495],
        // "campaignId": Number(el.campaignId),
        // "flightId": Number(el.flight_id),
        // "adId": Number(el.ad_id)
      }
    );
    allDiv.push("div1");
    allDiv.push("div2");
    allDiv.push("div3");
    count = count + 1;
    // if (this.streamAdsData.length == count) {
    let data = {
      "placements": placements,
      "allDiv": allDiv
    };
    if (this.org_info.vod_site_id && this.org_info.advertiser_id) {
      //"?NOLOADER"
      this.commonSubscribeService.getAdsData(data, (err, result) => {
        //console.log(result, "adsresult")
        if (result && result.status == 0 && result.Ads_data.length > 0) {
          //console.log(result.Ads_data, 'test');
          result.Ads_data.forEach(element => {

            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "1280x720") {
              this.preloadAdsdata.push(element);
            }
          });

          if (this.preloadAdsdata.length > 0) {

            if (this.noloader) {
              this.noloader = false;
              this.AdsCount = this.preloadAdsdata.length;
              if (!from) {
                this.midRollAds(this.preloadAdsdata);
              }
            } else {
              // this.preRollAds();
              this.AdsCount = (this.preloadAdsdata.length > 2) ? 2 : this.preloadAdsdata.length;
              if (!from) {
                this.midRollAds(this.preloadAdsdata);
              }
            }
          }

          // if (this.rightAds.length > 0) {
          //   this.rightAdsCount = this.rightAds.length;
          //   this.rightRollAds(this.rightAds);
          // }
        }


      });

    }
    // }
    // });
    // }


  }

  selectedAdData: any;
  async midRollAds(midRollAdsdata) {
    // debugger;
    this.AdsCount = (this.AdsCount - 1);
    this.selectedAdData = midRollAdsdata[this.AdsCount].clickUrl;
    let index = this.AdsCount;
    if (midRollAdsdata[index].contents && midRollAdsdata[index].contents[0] && midRollAdsdata[index].contents[0].body) {
      let adType = midRollAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};
      this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      this.showAd = true;
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;
      this.setTimer(minplayTime, () => { });
      if (midRollAdsdata[index].impressionUrl) {
        this.commonSubscribeService.countAdsImpressions(midRollAdsdata[index].impressionUrl);
      }
      setTimeout(() => {
        this.closeAdd();
      }, maxPlayTime);
      this.playStopAudio('pause', 'UI');
    }
    this.loadscript();
  }
  loadscript() {
    $(document).ready(function () {
      $('.adright img').attr('alt', ' ');
      $('.adright img').attr('title', ' ');
      $('.adcenter img').attr('alt', ' ');
      $('.adcenter img').attr('title', ' ');
      $('.ad img').attr('alt', ' ');
      $('.ad img').attr('title', ' ');
      $('.adcenter').find('video').each(function () {
        this.muted = true;
      });
      $('.adright').find('video').each(function () {
        this.muted = true;
      });


    });
  }
  closeButton: boolean = false;
  closeAdd() {
    if (this.showSkip) {
      if (this.AdsCount > 0 && this.preloadAdsdata.length > 0) {
        this.midRollAds(this.preloadAdsdata);
      } else {
        this.AdsCount = 0;
        // this.preloadAdsdata = [];
        this.closeButton = true;
        this.showAd = false;
        this.showSkip = false;
        this.showTimer = false;

        // if (!this.isStartedPhenixStream) {
        //   this.startSubscribeStream();
        // }
        // if (this.AdsCount && !this.showAd) {
        // }
        this.playingAds = false;
        this.playStopAudio('play', 'UI');
      }
    }

  }
  seconds_data: any;
  showSkip: boolean = false;
  setTimer(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.seconds_data = "Skip Ads";
        this.showSkip = true;
      } else {
        this.seconds_data = "Skip Ads in " + (playTime - j);
      }
      this.showTimer = true;
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }

  songsCount = 0;
  playingAds: boolean = false;
  liveEventSubscr: Subscription;
  UserSubData = [];
  toggleAudio(data, index) {
    this.UserSubData = [];
    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    let icsettingsData = this.commonSubscribeService.icWebpageSettingsData;
    let benefitPlan: any;
    let networkBenefits: any = {};
    let channelBenefits: any = {};
    let currentChannelId: any;
    let haveChannelPlan = false;
    let subscribedPlan: any;

    this.UserSubData = this.userService.userSub;
    console.log(this.UserSubData, "newData")

    if (perfomerInfoData && perfomerInfoData.data) {
      if (perfomerInfoData.data.Subscription_details && perfomerInfoData.data.Subscription_details.length > 0) {
        subscribedPlan = perfomerInfoData.data.Subscription_details;
      }
      currentChannelId = icsettingsData && icsettingsData.channelInfo && icsettingsData.channelInfo.channel_id ? icsettingsData.channelInfo.channel_id : 0;
      if (subscribedPlan && subscribedPlan.length > 0) {
        subscribedPlan.forEach(plan => {
          if (currentChannelId == 0 && plan.channel_id == 0) {
            networkBenefits = plan.benefits;
          } else {
            if (plan.channel_id == currentChannelId && currentChannelId != 0) {
              channelBenefits = plan.benefits;
              //console.log("perfomerInfoData", benefitPlan)
            }
          }
        });
      }
      if (perfomerInfoData.data.Data && perfomerInfoData.data.Data[0] && perfomerInfoData.data.Data[0].plans && perfomerInfoData.data.Data[0].plans) {
        let plans = perfomerInfoData.data.Data[0].plans;
        if (plans && plans.length > 0 && currentChannelId != 0) {
          plans.forEach(plan => {
            if (plan.channel_id == currentChannelId) {
              haveChannelPlan = true;
            }
          });
        }
      }
      if ((networkBenefits.ads == 1 && currentChannelId == 0) || (networkBenefits.ads == 1 && !haveChannelPlan) || (channelBenefits.ads == 1) || this.preloadAdsdata.length == 0) {
        this.noAds = true;
      }
    }

    this.commonSubscribeService.sendCurrentMusicData(data);
    //console.log(this.preloadAdsdata, "this.preloadAdsdata")
    this.musicList.forEach((element: any, i) => {
      if (index != i) {
        element.playing = false;
        // let ele: any = document.getElementById("audio_" + i);
        // if (ele) {
        //   ele.pause();
        // }
      }
    });
    let music_List = Math.floor(this.musicListLength);
    console.log(this.songsCount, "this.songsCounts")
    if (((this.songsCount >= 4) || (this.songsCount == 0 && this.playedFromAlbum != "" && this.albumstatus)) && !this.noAds) {
      this.getAds();
      this.playingAds = true;
      if (this.playedFromAlbum != "" && this.albumstatus) {
        this.albumstatus = false;
        this.playedFromAlbum = ""
      }
      if (this.songsCount >= 4) {
        this.songsCount = 0;
      }

    }
    //console.log(this.selected_music, data, "showingdata");
    if (this.selected_music.streamid != data.streamid && this.selected_music.activeMusicIndex != index) {
      this.songsCount += 1;
    }
    //console.log(this.songsCount, music_List, this.musicList.length, "songsCount")
    if (this.activatedRoute.snapshot.queryParams && (Number(this.activatedRoute.snapshot.queryParams.id) != data.streamid)) {
      this.currentPlayerTime = "00:00";
      this.totalPlayerTime = "00:00";
    } else if (this.activatedRoute.snapshot.queryParams && (Number(this.activatedRoute.snapshot.queryParams.id) == data.streamid) && (this.selected_music && this.selected_music.streamid == Number(this.activatedRoute.snapshot.queryParams.id)) && this.currentPlayerTime != "00:00") {
      console.log(this.selected_music, "datamusic")
      // console.log("playstopui", this.playingAds);
      // this.currentPlayerTime = "00:00";
      // this.totalPlayerTime = "00:00";
      if (!this.playingAds) {
        if (this.selected_music.playing)
          this.playStopAudio('pause', 'UI');
        else
          this.playStopAudio('play', 'UI');
        return;
      }
    }
    this.musicList.forEach((element: any, i) => {
      if (index != i) {
        element.playing = false;
        // let ele: any = document.getElementById("audio_" + i);
        // if (ele) {
        //   ele.pause();
        // }
      }
    });
    let new_array = []
    this.musicList.forEach((element: any, i) => {
      if (index != i) {
        element.playing = false;
        // let ele: any = document.getElementById("audio_" + i);
        // if (ele) {
        //   ele.pause();
        // }
      }
      let a = { "id": element.streamid, "index": i, "currentindex": index }
      new_array.push(a)
    });
    console.log(new_array, "getting the streaming data")
    if (!data.playing) {
      if (!data.stream_info.video_url_secure) {
        this.ngxLoader.start();
        this.getSignedURL(data.stream_info.video_url, res => {
          this.ngxLoader.stop();
          data.stream_info.video_url_secure = res;
          data.playing = true;
          this.commonSubscribeService.trackGoogleAnalytics('play_song');
          this.commonSubscribeService.trackFBEvents('ViewContent');
          // if (ele) {
          //   ele.play();
          // }
          this.selected_music = data;
          this.selected_music.activeMusicIndex = index;
          this.selected_music.playing = true;
          // console.log("playstopui", this.playingAds);
          if (!this.playingAds) {
            this.playStopAudio("play");
          }
          this.updateMusicArray(data, index);
          this.appService.currentPlayingAudio.next(this.selected_music)
        });
      } else {
        data.playing = true;
        // if (ele) {
        //   ele.play();
        // }
        this.selected_music = data;
        this.selected_music.activeMusicIndex = index;
        this.selected_music.playing = true;
        // console.log("playstopui", this.playingAds);
        if (!this.playingAds) {
          this.playStopAudio("play", "UI");
        }
        this.updateMusicArray(data, index);
      }
    } else {
      data.playing = false;
      // if (ele) {
      //   ele.pause();
      // }
      // this.selected_music = {};
      this.playStopAudio("stop");
      this.selected_music.playing = false;
      this.updateMusicArray(data, index);
    }
    // console.log("playstopui", this.playingAds, this.noAds);
    if (!this.playingAds && !this.noAds)
      this.playStopAudio('play', 'UI');
  }

  playStopAudio(from, clickFrom?) {
    let ele: any = document.getElementById("audio_1");
    if (ele) {
      if (from == "play") {
        //console.log("playing data")
        ele.pause();
        if (!clickFrom) {
          ele.load();
        }
        setTimeout(() => {
          ele.play();
        }, 1000);
        this.startStreamSession();
      } else {
        ele.pause();
        this.endSessionWithStreamMetrics();
      }
    }

    if (clickFrom == "UI") {
      this.musicList.forEach((element: any, i) => {
        if (this.selected_music.activeMusicIndex == i) {
          if (from == "play") {
            element.playing = true;
            this.selected_music.playing = true;
          } else {
            element.playing = false;
            this.selected_music.playing = false;
          }
        }
      });
    }
    let new_array = []
    this.musicList.forEach((element: any, i) => {
      if (this.selected_music.streamid != element.streamid) {
        element.playing = false;
        // let ele: any = document.getElementById("audio_" + i);
        // if (ele) {
        //   ele.pause();
        // }
      }
      let a = { "id": element.streamid, "index": i, "currentindex": this.selected_music.streamid }
      new_array.push(a)
    });
    console.log(new_array, "getting the streaming data1")
    this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.musicList });
  }

  prevAudio() {
    if (!this.is_shuffle && this.canplayPrev()) {
      for (let i = this.selected_music.activeMusicIndex - 1; i >= 0; i--) {
        const element: any = this.musicList[i];
        if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
          element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)) || (element.stream_info.stream_payment_mode == "folder" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id)) || ((element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.id)) || (element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) || (this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) {
          this.toggleAudio(element, i);
          break;
        }
      }
    } else if (this.is_shuffle) {
      if (this.shuffleArrayActiveIndex == 0) {
        this.shuffleArrayActiveIndex = this.shuffleArray.length;
      } else {
        this.shuffleArrayActiveIndex--;
      }
      let element = this.shuffleArray[this.shuffleArrayActiveIndex];
      for (let i = 0; i < this.musicList.length; i++) {
        const e1 = this.musicList[i];
        if (element.streamid == e1.streamid) {
          this.toggleAudio(element, i);
          break;
        }
      }
    }
  }

  nextAudio() {
    if (!this.is_shuffle && this.canplayNext()) {
      for (let index = this.selected_music.activeMusicIndex + 1; index < this.musicList.length; index++) {
        const element: any = this.musicList[index];
        if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
          element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)) || (element.stream_info.stream_payment_mode == "folder" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id)) || ((element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.id)) || (element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) || (this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) {
          this.toggleAudio(element, index);
          break;
        }
      }
    } else if (this.is_shuffle) {
      if (this.shuffleArrayActiveIndex == this.shuffleArray.length - 1) {
        this.shuffleArrayActiveIndex = 0;
      } else {
        this.shuffleArrayActiveIndex++;
      }
      let element = this.shuffleArray[this.shuffleArrayActiveIndex];
      for (let i = 0; i < this.musicList.length; i++) {
        const e1 = this.musicList[i];
        if (element.streamid == e1.streamid) {
          this.toggleAudio(element, i);
          break;
        }
      }
    }
  }

  currentPlayerTime: any = "00:00";
  totalPlayerTime: any = "00:00";
  is_repeat = false;
  is_shuffle = false;
  repCount = 0;
  getAudioTime() {
    let audio: any = document.getElementById("audio_1");
    if (audio.currentSrc && audio.currentTime && audio.duration) {
      this.appService.currentPlayingAudioTime.next(Math.floor(audio.currentTime))
      let per = audio.currentTime * 100 / audio.duration;
      if (per >= 99) {
        per = Math.round(per);
      }
      let pr_id = document.getElementById("progressBarColor");
      pr_id.style.width = per.toString() + "%";
      this.currentPlayerTime = this.playerTime(audio.currentTime);
      this.totalPlayerTime = this.playerTime(audio.duration);
      if (per >= 100) {
        audio.currentTime = 0;
        audio.pause();
        if (this.is_repeat) {
          this.repCount += 1;
          if (this.songsCount > 5) {
            this.getAds()
            this.repCount = 0;
          }
          audio.play();
        } else if (this.canplayNext()) {
          this.nextAudio();
        } else {
          this.currentPlayerTime = "00:00";
          this.totalPlayerTime = "00:00";
          this.selected_music.playing = false;
          this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.musicList });
          this.commonSubscribeService.lastAudioEndedSubject.next('success');
        }
        return "00:00" + " / " + "00:00";
      } else {
        return this.playerTime(audio.currentTime) + " / " + this.playerTime(audio.duration);
      }
    } else {
      let pr_id = document.getElementById("progressBarColor");
      pr_id.style.width = "0%";
      return "";
    }
  }

  openPolls(){
    const dialogRef = this.dialog.open(TipsFeedbackPopupComponent, {
      data: {type:'polls'},
      width: '550px',
      height: '560px',
      panelClass: 'app-tips-polls',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "yes") {
        
      }
    });
  }

  openTips(){
    const dialogRef = this.dialog.open(TipsFeedbackPopupComponent, {
      data: { type:'tips'},
      width: '550px',
      height: '560px',
      panelClass: 'app-tips-polls',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "yes") {
        
      }
    });
  }

  keepRepeat() {
    this.is_repeat = !this.is_repeat;

  }

  keepShuffle() {
    this.is_shuffle = !this.is_shuffle;
    if (this.is_shuffle) {
      this.getShuffleArray(this.musicList);
    }
  }

  playerTime(e) {
    var m = Math.floor(e % 3600 / 60).toString().padStart(2, '0'),
      s = Math.floor(e % 60).toString().padStart(2, '0');
    return m + ':' + s;
  }

  getSignedURL(filename, cb) {
    let url = filename.split("/");
    let signeURL = url.slice(-3).join("/");
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: { "name": signeURL, "type": "get" }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_URL, data).then(response => {
      if (response) {
        //console.log(response);
        signeURL = response.data.signed_url;
        cb(signeURL);
      }
    }).catch(error => {
      cb(signeURL);
      console.log(error);
    });
  }

  // volumeSliderSliding(args: any): void {
  //   console.log("args",args);
    
  //   this.audioVolume = args.value;
  //   let audio: any = document.getElementById("audio_1");
  //   if (audio) {
  //     audio.volume = this.audioVolume;
  //   }
  // }

  volumeSliderSliding(args: any): void {
    console.log("args", args);
    let sliderValue = parseFloat(args.target.getAttribute('aria-valuetext') || '0');
    this.audioVolume = isNaN(sliderValue) ? 0 : Math.max(0, Math.min(1, sliderValue));
    let audio: any = document.getElementById("audio_1");
    if (audio) {
      audio.volume = this.audioVolume;
    }
  }
  

  volumeSliderChanged(args: any): void {
    if (!!args && !!args.source._lastPointerEvent) {
      return;
    }
    let audio: any = document.getElementById("audio_1");
    if (audio && audio.volume == 0) {
      //mute icon on
    } else {

      //unmute icon on
    }
  }

  muteUnmutePlayerAudio(from) {
    let audio: any = document.getElementById("audio_1");
    if (audio) {
      if (from == "unmute") {
        this.audioVolume = 0.7;
        audio.volume = this.audioVolume;
      } else {
        this.audioVolume = 0;
        audio.volume = this.audioVolume;
      }
    }
  }

  canplayNext() {
    let flag = false;
    if (this.is_shuffle) {
      flag = true;
    } else if (this.musicList && this.musicList.length == this.selected_music.activeMusicIndex + 1) {
      flag = false;
    } else if (this.musicList && this.musicList.length > 0) {
      for (let i = this.selected_music.activeMusicIndex + 1; i < this.musicList.length; i++) {
        const element: any = this.musicList[i];
        // console.log(element.stream_info, element.stream_info.id, element.stream_info.stream_payment_mode, this.UserSubData && this.UserSubData.length, this.UserSubData.includes(element.stream_info.id), "newData")
        // console.log(element, element.stream_info, element.stream_info.stream_payment_mode, element.plans, this.subscribedUserPlans, this.subscribedUserPlans[0].plan_id, element.plans, "plans for data")
        // console.log()
        if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
          element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)) || (element.stream_info.stream_payment_mode == "folder" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id)) || ((element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.id)) || (element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) || (this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) {
          flag = true;
          break;
        }
      }
    }
    return flag;
  }

  canplayPrev() {
    let flag = false;
    if (this.is_shuffle) {
      flag = true;
    } else if (this.selected_music.activeMusicIndex == 0) {
      flag = false;
    } else if (this.musicList && this.musicList.length > 0) {
      let list = JSON.parse(JSON.stringify(this.musicList));
      list.splice(this.selected_music.activeMusicIndex, this.musicList.length);
      list.reverse();
      for (let i = 0; i < list.length; i++) {
        const element: any = list[i];
        if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
          element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)) || (element.stream_info.stream_payment_mode == "folder" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id)) || ((element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.id)) || (element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) || (this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id))) {
          flag = true;
          break;
        }
      }
    }
    return flag;
  }

  updateMusicArray(data, index) {
    this.musicList.forEach((element, i) => {
      if (i == index) {
        element = data;
        this.selected_music.stream_info = data.stream_info;
      }
    });
    let new_array = []
    this.musicList.forEach((element: any, i) => {
      if (i) {
        // element.playing = false;
        // let ele: any = document.getElementById("audio_" + i);
        // if (ele) {
        //   ele.pause();
        // }
      }
      let a = { "id": element.streamid, "index": i, "currentindex": index }
      new_array.push(a)
    });
    console.log(new_array, "getting the streaming data2")
    this.commonSubscribeService.sendMediaPlayerData({ key: "musicList", value: this.musicList });
  }

  startSessionResponse: any = {};
  startStreamSession() {
    let reqData: any = this.selected_music.stream_info;
    let artistDetails: any = this.selected_music && this.selected_music.metadata ? JSON.parse(this.selected_music.metadata.additional_info) : '';
    let artistInfo = artistDetails.performingRightsOrganization;
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user_id": this.userInfo.id,
        "event_id": reqData.id,
        "organization_id": reqData.organization_id,
        "performer_id": reqData.performer_id,
        "stream_type": "audio",
        "title": reqData.stage,
        "artist": artistInfo && artistInfo.artist ? artistInfo.artist : undefined,
        "album": reqData.stream_video_title,
        "artist_id": artistInfo && artistInfo.artist_id ? artistInfo.artist_id : undefined,
        "stream_id": reqData.parent_streams_id,
        "network_group_id": reqData.network_group_id || 0
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.START_SESSION, data).then(response => {
      if (response.data.statusCode === '200') {
        this.startSessionResponse = response['data'];
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
    //console.log(data)
  }


  endSessionWithStreamMetrics() {
    let url = CONST_AWS_API.END_SESSION;
    let id = this.startSessionResponse ? this.startSessionResponse['Data'] : 0;
    let session_start_time = this.startSessionResponse ? this.startSessionResponse['session_start_time'] : "";
    let reqData: any = this.selected_music.stream_info;

    let data = {
      headers: { 'x-api-key': environment.AWS_Cognito.X_Api_Key },
      response: true,
      body: reqData ? {
        "id": id,
        "session_start_time": session_start_time,
        "is_final": true,
        "event_id": reqData.id,
        "image_for": 'stream_metrics/' + reqData.stream_video_code + "/" + id,
        "stream_type": "audio",
        "network_group_id": reqData.network_group_id || 0
      } : {}
    }
    if (reqData) {
      AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      }, error => {
        console.log("error");
      });
    }
  }

  shuffleArray: any = [];
  shuffleArrayActiveIndex = 0;
  getShuffleArray(array) {
    let newArray = [];
    for (let index = 0; index < array.length; index++) {
      const element: any = array[index];
      if (!element.stream_info.stream_payment_mode || element.stream_info.stream_payment_mode == 'free' ||
        element.stream_info.stream_payment_mode == 'free_ads' || (element.plans && this.subscribedUserPlans.length > 0 && element.plans.includes(this.subscribedUserPlans[0].plan_id)) || (element.stream_info.stream_payment_mode == "folder" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.parent_streams_id)) || (element.stream_info.stream_payment_mode == "paid" && this.UserSubData && this.UserSubData.length > 0 && this.UserSubData.includes(element.stream_info.id))) {
        newArray.push(element);
      }
    }
    for (var i = newArray.length - 1; i > 0; i--) {
      // Generate random number
      var j = Math.floor(Math.random() * (i + 1));
      var temp = newArray[i];
      newArray[i] = newArray[j];
      newArray[j] = temp;
    }
    this.shuffleArray = newArray;
    this.shuffleArrayActiveIndex = 0;
  }

  ngOnDestroy() {
    if (this.settingsDataSubscription) {
      this.settingsDataSubscription.unsubscribe();
    } if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    } if (this.mediaPlayerDataSubscription) {
      this.mediaPlayerDataSubscription.unsubscribe();
    }
    if (this.audioInterval)
      clearInterval(this.audioInterval);
  }

}
